import Vue from 'vue';
export default Vue.extend({
    props: {
        insOrderInfo: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            isShow: false,
            // insOrderInfo: null,
            orderTables: [
                {
                    label: '险种',
                    key: 'policyTypeName',
                },
                {
                    label: '保单号',
                    key: 'policyNo',
                },
                {
                    label: '批单号',
                    key: 'endorseNo',
                },
                {
                    label: '保费',
                    key: 'premiumFee',
                },
                {
                    label: '保险公司',
                    key: 'insCompanyName',
                },
                {
                    label: '投保城市',
                    key: 'insuranceCityName',
                },
                {
                    label: '投保人',
                    key: 'applicantName',
                },
                {
                    label: '投保人证件类型',
                    key: 'applicantCertificateTypeName',
                },
                {
                    label: '投保人证件号码',
                    key: 'applicantCertificateNo',
                },
                {
                    label: '被保险人',
                    key: 'insurantName',
                },
                {
                    label: '被保险人证件类型',
                    key: 'insurantCertificateTypeName',
                },
                {
                    label: '被保险人证件号码',
                    key: 'insurantCertificateNo',
                },
                {
                    label: '保险起期',
                    key: 'insuranceBeginTime',
                },
                {
                    label: '保险止期',
                    key: 'insuranceEndTime',
                },
                {
                    label: '签单日期',
                    key: 'createTime',
                },
            ],
            vehicleTables: [
                {
                    label: '车牌号',
                    key: 'plateNo',
                },
                {
                    label: '车架号',
                    key: 'vin',
                },
                {
                    label: '发动机编号',
                    key: 'engineNo',
                },
                {
                    label: '初登日期',
                    key: 'registerDate',
                },
                {
                    label: '新/旧车',
                    key: 'vehicleTypeName',
                },
                {
                    label: '营运/非营运车',
                    key: 'vehicleUseTypeName',
                },
                {
                    label: '车主姓名',
                    key: 'ownerName',
                },
                {
                    label: '车主证件号',
                    key: 'ownerCertificateNo',
                },
            ],
        };
    },
    methods: {
        showSelf: function () {
            this.isShow = true;
        },
    },
});
